import { useState } from "react";

export default function IpFinder() {
  const [ip, setIp] = useState("");
  const [gateway, setGateway] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchIP = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      setIp(data.ip);
    } catch (err) {
      setError("Failed to fetch IP address");
    }
    setLoading(false);
  };

  const fetchGateway = async () => {
    setLoading(true);
    setError("");
    try {
      // NOTE: Browsers cannot directly access local network gateway
      // This is a placeholder / simulated value
      setGateway("192.168.1.1 (Typical Default Gateway)");
    } catch (err) {
      setError("Failed to fetch Gateway");
    }
    setLoading(false);
  };

  return (
    <>
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">
          IP & Gateway Finder
        </h1>

        <button
          onClick={fetchIP}
          className="w-full bg-blue-500 text-white py-2 rounded-xl mb-4 hover:bg-blue-600"
        >
          Get Public IP
        </button>

        {ip && (
          <p className="text-center mb-4">
            <strong>Your IP:</strong> {ip}
          </p>
        )}

        <button
          onClick={fetchGateway}
          className="w-full bg-green-500 text-white py-2 rounded-xl mb-4 hover:bg-green-600"
        >
          Get Gateway (Simulated)
        </button>

        {gateway && (
          <p className="text-center mb-4">
            <strong>Gateway:</strong> {gateway}
          </p>
        )}

        {loading && <p className="text-center">Loading...</p>}
        {error && <p className="text-center text-red-500">{error}</p>}
      </div>
    </div>
    </>
  );
}

